import type {UploadedFile, UploadedFileUpdate} from 'generated-api';
import type {AppDispatch} from 'index';
import {createUploadedFile, updateUploadedFile} from 'store/editorTest';

/**
 * Files are stored directly in the object storage: register the file to obtain a
 * presigned URL, PUT the content there, then flag the record as uploaded.
 */
export const uploadFile = async (
    dispatch: AppDispatch,
    file: File,
    isPublic: boolean
): Promise<UploadedFile | undefined> => {
    const f = (await dispatch(createUploadedFile({
        body: {
            file_name: file.name,
            mime_type: file.type,
            size: file.size,
            is_public: isPublic,
            is_uploaded: false
        }
    })))?.payload as UploadedFile;
    if (!f?.upload_url) {
        return;
    }

    const res = await fetch(new Request(f.upload_url, {
        method: 'PUT',
        headers: {
            'Content-type': file.type !== '' ? file.type : 'application/octet-stream'
        },
        body: file
    }));
    if (!res.ok) {
        return;
    }

    await dispatch(updateUploadedFile({
        id: f.id,
        body: {...f, is_uploaded: true} as any as UploadedFileUpdate
    }));

    return f;
};
